import ZoneInputs from "./components/ZoneInputs";
import CreatedZones from "./components/CreatedZones";
import { useState } from "react";

interface ZoneFormProps {
  handleClose: () => void;
}

const ZoneForm = (props: ZoneFormProps) => {
  const { handleClose } = props;
  const [loading, setLoading] = useState(false);

  return (
    <>
      <ZoneInputs setIsModalOpen={handleClose} setLoading={setLoading} />
      <hr />
      <CreatedZones />
    </>
  )
}

export default ZoneForm;